import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ok-circle",
  "use": "ok-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ok-circle\">\n  <path fill-rule=\"evenodd\" d=\"M312.439,92.01a1,1,0,0,1-1.414,0l-1.536-1.535A1,1,0,0,1,310.9,89.06l0.829,0.829,3.364-3.364a1,1,0,0,1,1.414,1.414ZM313,81a8,8,0,1,0,8,8A8,8,0,0,0,313,81Z\" transform=\"translate(-305 -81)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ok-circle.svg
// module id = null
// module chunks = 